import React, { useEffect, useState } from 'react';
import { ListItem } from '../atoms/listitem';
import ListAltTwoToneIcon from '@material-ui/icons/ListAltTwoTone';

import { useDispatch, useSelector } from 'react-redux';

import variables from '../atoms/variables.json';

import BackComponent from './../atoms/backComponent';

import ProgressCircle from "./components/ProgressCircle"


import {
  CardWrapper,
  SubHeading,

} from './style';
import BottomButton from '../atoms/bottomButton';

import RentalWarrenty from './RentalWarrenty';

import Container from '../atoms/Container/Container';

import DrawerHoc from '../../../../components/drawerHOC';
import getPlatformType from '../../../../helpers/helpers';
import { CardBox } from '../atoms/card';
import IdBox from './idBox';

const agreementsCol = [{ title: 'Court' }, { title: 'Amount' }, { title: 'Order Date' }];

const judgmentsCol = [{ title: 'Court' }, { title: 'Amount' }, { title: 'Date' }];
const layoutType = getPlatformType();
const TenantIdentification = (props) => {
  const dispatch = useDispatch();
  const [tenants, setTenants] = React.useState([]);
  const [flowId, setFlowId] = React.useState(null);

  const [warranty, setWarranty] = React.useState(null);
  const [obxPropertyId, setObxPropertyId] = React.useState(null);

  const idendityData = useSelector((state) => state?.tenant?.flowIdInfo);



  const modalGlobalObject = useSelector((state) => state?.tenant?.idendityData);

  useEffect(() => {
    setWarranty(idendityData?.OpenFlowRentalWarranty)
    setObxPropertyId(idendityData?.property_id)
  }, [idendityData?.OpenFlowRentalWarranty]);

  useEffect(() => {
    if (props?.route?.params?.id) {
      setFlowId(props?.route?.params?.id);
 
    }
  }, [props?.route?.params?.id]);



 


  const _onSave = (data) => {
    let payload = {
      tenants: tenants,
      ...data,
    };
    // dispatch(tenantActions.saveIdentityData(payload, flowId));
  };

  return (
    <Container>
      <CardWrapper>
      <ProgressCircle props={props}/>
        {/* <ListItem
          type={'complete'}
          title={'Tenant Identification'}
          listIcon={<ListAltTwoToneIcon style={{ fontSize: '25px', color: variables.purple1 }} />}
          // icon={ID_ICON}
          showPropertyCard
          description={`All Applicant Tenant(s) Identification and Verification is received from TLyfe which interacts with OpenFlo to maximise the process efficiency and referral fees.`}
        />

        <BackComponent
          id={flowId}
          isComplete={idendityData?.flow?.verification_status == 1 ? true : false}
          flowtype={'verification_status'}
        /> */}
         <BackComponent
          id={flowId}
          isComplete={modalGlobalObject?.verification_status === 1 ? true : false}
          flowtype="verification_status"
        />
        <IdBox props={props}/>

        <RentalWarrenty warranty={warranty} flowId={flowId} obxPropertyId={obxPropertyId}>
          {' '}
        </RentalWarrenty>

        <BottomButton
          showSendbutton={false}
          showContinueModal={false}
          onContinue={() => {
            _onSave();
          }}
        />
      </CardWrapper>

  
    </Container>
  );
};

export default DrawerHoc({
  Component: TenantIdentification,
  showBackButton: true,
    backNavigation:"CurrentOnboards" 
});
